import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import './editorStyles.css';

const modules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['clean']
    ]
};

const formats = [
    'header', 'bold', 'italic', 'underline',
    'list', 'bullet', 'indent'
];

const RichTextEditor = (props: any) => {
    return (
        <div>
            <ReactQuill
                value={props.releaseNotesModel.notes}
                onChange={(e: any) => props.setReleaseNotesModel((prev) => ({ ...prev, notes: e }))}
                modules={modules}
                formats={formats}
                placeholder="Start typing..."
            />
        </div>
    );
};

export default RichTextEditor;